import { useMemo, useEffect } from 'react'

type IUseStoreMemo = {
  init: () => void
  dispose?: () => void
}

export const useStoreMemo = <Store extends IUseStoreMemo, Params extends unknown[]>(
  StoreClass: new (...args: Params) => Store,
  ...args: Params
) => {
  const memoStore = useMemo(() => new StoreClass(...args), [])

  useEffect(() => {
    memoStore.init()
  }, [])

  // unmount hook
  useEffect(
    () => () => {
      memoStore.dispose?.()
    },
    []
  )

  return memoStore
}
